import DesignSelect from './DesignSelect'

export default DesignSelect
